import React, { useEffect, useState } from 'react';
import { Col, Row, Tabs } from 'antd';
import Modal from 'react-modal';
import { PulseLoader } from 'react-spinners';
import moment from 'moment';
import { onlyNumberForNumberType, removeNumbersAndSpecialCharacters } from '@helpers';
import EdenRedCard from '@sharedComponent/card';
import EdenredHeader from '@pages/main-layout/components/main-header';
import ETypo from '@pages/DesignSystem/Typo';
import EdenredButtons from '@pages/DesignSystem/button/EdenredButton';
import EDragger from '@pages/DesignSystem/Dragger';
import Inputbox from '@pages/DesignSystem/Input-Field';
import HintCard from '@pages/DesignSystem/hint-card';
import { focus_state_icons } from 'src/assets/icons/focus_state';
import DatePickers from '@pages/DesignSystem/date-flat-picker';
import Edenredmodal from '@pages/DesignSystem/Edenredmodal';
import PayrollService from 'src/services/payroll-service';
import ClevertapReact from 'src/utils/clever-tap';
import Toast from '@pages/DesignSystem/Toast';
import CustomDragger from './CustomDragger';
import PaymentFlowPopup from './PaymentFlowPopup';
import ImageComponent from '@sharedComponent/image-component';
import { useHistory } from 'react-router-dom';
import { icons } from '@assets/icons';
import { useSelector } from 'react-redux';
import { CorporateService } from 'src/services';

const { TabPane } = Tabs;

const ProofOfTransferPresentational = () => {
	const _payrollService = new PayrollService();
	const [modalDrag, setModalDrag] = useState(false);
	const [selectedFile, setSelectedFile] = useState({});
	const [selectedAmount, setSelectedAmount] = useState();
	const [senderName, setSenderName] = useState();
	const [senderNames, setSenderNames] = useState([]);
	const [showDropdown, setShowDropdown] = useState(false);
	const [senderNamesLoading, setSenderNamesLoading] = useState(false);
	const [loading, setLoading] = useState(false);
	const [proof, setProof] = useState([]);
	const [contentLoading, setContentLoading] = useState(true);
	const [IsPopupVisible, setIsPopupVisible] = useState(false);
	const [popupMessage, setPopupMessage] = useState({ titleMessage: '', subMessage: '' });
	const [isUpload, setIsUpload] = useState(false);
	const [isFileSize, setIsFileSize] = useState(false);
	const [activeTabKey, setActiveTabKey] = useState('1');
	const [proofDateSelected, setProofDateSelected] = useState('');
	const [toastMessageShow, setToastMessageShow] = useState(false);
	const [featureExists, setFeatureExists] = useState(null);
	const [fileDisabled, setFileDisabled] = useState(true);
	const [apiLoading, setApiLoading] = useState(false);
	const [paymentCheckFlowCompleted, setPaymentCheckFlowCompleted] = useState(false);
	const [paymentCheckFlowInitialPopup, setPaymentCheckFlowInitialPopup] = useState(false);
	const [transferCodePopup, setTransferCodePopup] = useState(false);
	const [proofNotNeededPopup, setProofNotNeededPopup] = useState(false);
	const history = useHistory();
	const transferCode = useSelector((state) => state.sharedStates.transferCode) || null;

	const fetchSenderNames = async () => {
		setSenderNamesLoading(true);
		try {
			const res = await _payrollService.getSenderNames();
			setSenderNames(res.data);

		} catch (error) {
			setSenderNames([]);
		} finally {
			setSenderNamesLoading(false);
		}
	};

	const getAllFundTransferHistory = (page, firstTime = false) => {
		let params = {};
		params['pageNumber'] = page ? page : 1;
		params['pageSize'] = 20;
		setContentLoading(true);
		_payrollService
			.getFundTransferHistory(params)
			.then((res) => {
				setContentLoading(false);
				if (res && res.data && res.data?.receipts) {
					let resArr = [];
					res.data.receipts?.length &&
						res.data.receipts.forEach((receipt) => {
							let receiptObj = {};
							receiptObj.id = receipt.id;
							receiptObj.header = `AED ${receipt.amount}`;
							receiptObj.title = moment(receipt.depositDate).format('DD MMMM YYYY'); //'21 July 2020';
							receiptObj.detail = receipt.statusDescription;
							// rejection reason we getting from the notes property
							receiptObj.reason = receipt?.notes;
							receiptObj.background = receipt.color === '#07b841' ? '#8EF9B3' : receipt.color === '#E4DD3D' ? '#FFDC91' : '#FF9691';
							receiptObj.fileName = receipt.fileName;
							receiptObj.image =
								receipt?.status === 'Approved'
									? focus_state_icons?.hrDocumentUptoDate
									: receipt?.status === 'Submitted'
										? focus_state_icons?.payrollTransferHistory
										: focus_state_icons?.hrDocumentExpired;
							resArr.push(receiptObj);
						});
					firstTime ? setProof([...resArr]) : setProof([...proof, ...resArr]);
				}
			})
			.catch((error) => {
				setContentLoading(false);
				setProof([]);
			});
	};

	useEffect(() => {
		if (proof.length > 0) tableScrollEvent();
	}, [proof.length]);

	const [pageNumber, setPageNumber] = useState(1);
	useEffect(() => {
		if (contentLoading) {
			getAllFundTransferHistory(pageNumber);
		}
	}, [pageNumber]);

	const setCallPageNumber = async (page) => {
		setPageNumber(page);
	};

	const tableScrollEvent = () => {
		const node = document.querySelector('.fund_transfer_history');

		if (node) {
			node.addEventListener('scroll', async () => {
				const percentage = (await (node.scrollTop / (node.scrollHeight - node.clientHeight))) * 100;
				if (percentage >= 99.9) {
					await setCallPageNumber((pageNumber) => pageNumber + 1);
				}
			});
		}
	};

	useEffect(() => {
		if (featureExists === false) {
			setPaymentCheckFlowCompleted(true);
			setFileDisabled(false);
		}
		if (featureExists === true) {
			setPaymentCheckFlowInitialPopup(true);
		}
		return () => {
			setPaymentCheckFlowCompleted(false);
			setPaymentCheckFlowInitialPopup(false);
		};
	}, [featureExists]);

	useEffect(() => {
		fetchSenderNames();
		Modal.setAppElement('body');
	}, []);

	// Refetch sender names when returning to first tab
	useEffect(() => {
		if (activeTabKey === '1') {
			fetchSenderNames();
		}
	}, [activeTabKey]);


	const allowedFileTypes = ['image/jpeg', 'image/png', 'application/pdf'];

	const handleDragger = (file) => {
		const isLt4M = file.size / 1024 / 1024 < 4;
		setSelectedFile(file);
		if (allowedFileTypes.indexOf(file.type) >= 0) {
			setIsUpload(true);
			setIsFileSize(false);
			setModalDrag(false);
		} else if (isLt4M) {
			setIsUpload(false);
			setIsFileSize(true);
			setModalDrag(false);
		} else {
			setIsUpload(false);
			setIsFileSize(false);
			setModalDrag(true);
		}
	};
	const onRemoveUpload = () => {
		setSelectedFile({});
		setModalDrag(false);
		setIsUpload(false);
		setIsFileSize(false);
	};

	const onSubmitProof = async (request) => {
		let formData = new FormData();
		formData.append('receiptFile', selectedFile);
		formData.append('amount', request.amount);
		formData.append('depositDate', request.depositDate);
		if (!!request.senderName) {
			formData.append('senderName', request.senderName);
		}
		setLoading(true);
		_payrollService
			.submitProof(formData)
			.then((res) => {
				if (res) {
					setLoading(false);
					ClevertapReact.event('Submit_Proof', {
						amount: request.amount,
						depositDate: request.depositDate,
					});
					setIsPopupVisible(true);
					setPopupMessage({
						titleMessage: (
							<div>
								<div>Thanks for submitting your proof of funds!</div>
								<div>You do not need to send us a confirmation mail.</div>
								<div>We will update your balance and release your salaries automatically.</div>
							</div>
						),
						subMessage: null,
					});
					setFeatureExists(null);
					resetFields();
					setActiveTabKey('2');
				} else {
					setLoading(false);
				}
			})
			.catch((err) => {
				setLoading(false);
			});
	};

	const resetFields = () => {
		setSelectedFile({});
		getAllFundTransferHistory(null, true);
		setModalDrag(false);
		setSelectedAmount();
		setIsUpload(false);
		setIsFileSize(false);
		setProofDateSelected('');
		setSelectedAmount('');
		setSenderName('');
	};

	const handleTabClick = (e) => {
		setActiveTabKey(e);
		if (e === 2) {
			if (proof.length > 0) {
				setTimeout(() => {
					tableScrollEvent();
				});
			}
		}
	};

	const closePopup = () => {
		setIsPopupVisible(false);
	};

	const draggerIcon = () => {
		if (isUpload) {
			return focus_state_icons.NewDesignCheck;
		} else if (isFileSize || modalDrag) {
			return focus_state_icons.NewDesignErro;
		} else {
			return focus_state_icons.hrUpload;
		}
	};
	const draggerStatus = () => {
		if (isUpload) {
			return 'done';
		} else if (isFileSize || modalDrag) {
			return 'error';
		} else {
			return 'new';
		}
	};
	const handleProofDate = (dateObj, formatStr) => setProofDateSelected(formatStr);
	const closeToast = () => {
		setToastMessageShow(false);
	};

	async function checkCorporates() {
		try {
			setApiLoading(true);
			const corporateService = new CorporateService();
			const res = await corporateService.getFeatureStatus('ProofOfFundsPopUp');
			if (res.data?.isActive) {
				setFeatureExists(true);
			} else {
				setFeatureExists(false);
			}
			setApiLoading(false);
		} catch (error) {
			setApiLoading(false);
		}
	}

	return (
		<>
			<Toast visible={toastMessageShow} color="#8EF9B3" textcolor="#484B52" clearPopUp={closeToast}>
				Your proof of funds has been deleted.
			</Toast>
			<PaymentFlowPopup
				isOpen={paymentCheckFlowInitialPopup}
				onClose={setPaymentCheckFlowInitialPopup}
				setFeatureExists={setFeatureExists}
				setPaymentCheckFlowCompleted={setPaymentCheckFlowCompleted}
				setTransferCodePopup={setTransferCodePopup}
			/>
			<Edenredmodal
				isOpen={transferCodePopup}
				title={`Did You Use Transfer Code : ${transferCode}`}
				onOkay={() => {
					setTransferCodePopup(false);
					setProofNotNeededPopup(true);
				}}
				onCancel={() => {
					setTransferCodePopup(false);
					setPaymentCheckFlowCompleted(true);
				}}
				topImage={<ImageComponent src={icons.focus_state.InvoiceFocusWithGrayBg} />}
				desc="If you have used Transfer code in your transfer, it will be auto reconciled and no need to submit proof of funds."
			/>
			<Edenredmodal
				isOpen={proofNotNeededPopup}
				title="You should not Upload Proof of Transfer Funds"
				onOkayButton="Go To Dashboard"
				onOkay={() => {
					history.push('/');
					setProofNotNeededPopup(false);
				}}
				topImage={<ImageComponent src={icons.focus_state.walletTickGreyBg} />}
				desc="Since you used the transfer code, the payment will be auto-reconciled, and no proof of funds is needed."
			/>

			<Edenredmodal isOpen={IsPopupVisible} title={popupMessage?.titleMessage} onOkayButton="Ok" onOkay={closePopup} />
			<Col className="proof_of_transfer_presentational_container">
				<EdenredHeader />
				<Row className="Proof-of-Transfer-presentational">
					<Col className="proof_of_find_transfer_header">
						<ETypo bold h2>
							Proof of Funds Transfer
						</ETypo>
						{activeTabKey === '1' && (
							<EdenredButtons
								loading={loading}
								disabled={!(selectedFile && selectedFile.name) || !proofDateSelected || !selectedAmount}
								onClick={() => {
									const format1 = 'YYYY-MM-DDThh:mm:ss';
									const dateTime = moment(proofDateSelected, 'DD/MM/YYYY').format(format1);
									let reqObj = {};
									reqObj.attachment = selectedFile.name;
									reqObj.depositDate = dateTime;
									reqObj.amount = selectedAmount;
									reqObj.senderName = senderName;
									onSubmitProof(reqObj);
								}}>
								Submit
							</EdenredButtons>
						)}
					</Col>
					<Col xl={24} lg={24} md={24} sm={24} xs={24} className="proof_of_find_transfer_tab">
						<Tabs onTabClick={handleTabClick} size="small" activeKey={activeTabKey}>
							<TabPane tab="Submit Proof" key="1">
								<Col className="upload_proof_of_fund_transfer">
									<Col xl={24} lg={24} md={24} sm={24} xs={24} className="upload">
										<ETypo bold h2 className="proof_of_fund_text">
											Upload Proof Of Funds Transfer:
										</ETypo>
									</Col>
									<Col xl={24} lg={24} md={24} sm={24} xs={24} className="cheques_mobile_view">
										Cheques may take up to 3 working days to clear before payroll can be run.
									</Col>
									<Col xl={24} lg={24} md={24} sm={24} xs={24} className="dragger_submit">
										{paymentCheckFlowCompleted ? (
											<EDragger
												{...{
													idleIcon: draggerIcon(),
													draggerStatus: draggerStatus(),
													uploadDeleteIcon: focus_state_icons.NewDelete,
													onChange: handleDragger,
													onRemoveUpload,
													acceptedTypes: '.jpg,.jpeg,.png,.pdf',
													fileFormat: '(JPG, JPEG, PNG, PDF) ',
													fileMaxSize: 'Max file size: 4Mb',
												}}
											/>
										) : (
											<div onClick={checkCorporates}>
												<CustomDragger
													{...{
														idleIcon: draggerIcon(),
														draggerStatus: draggerStatus(),
														uploadDeleteIcon: focus_state_icons.NewDelete,
														onChange: handleDragger,
														onRemoveUpload,
														acceptedTypes: '.jpg,.jpeg,.png,.pdf',
														fileFormat: '(JPG, JPEG, PNG, PDF) ',
														fileMaxSize: 'Max file size: 4Mb',
														fileDisabled: fileDisabled,
														loading: apiLoading,
													}}
												/>
											</div>
										)}
									</Col>
									{(isFileSize || modalDrag) && (
										<Col style={{ marginTop: '10px' }}>
											<HintCard
												{...{
													icon: focus_state_icons.hrDocumentExpired,
													bgColor: '#fff6f5',
													hint: isFileSize
														? 'File must be smaller than 4MB!'
														: modalDrag
															? `Invalid format. Please upload one of these formats ${allowedFileTypes.join()}`
															: '',
												}}
											/>
										</Col>
									)}
									<Col xl={24} lg={24} md={24} sm={24} xs={24} className="ProofOfTransfer_payment">
										<Col xl={6} lg={6} md={6} sm={24} xs={24} className="Payment_amount">
											<Inputbox
												label="Payment Amount On Slip"
												prefix={'AED'}
												onChange={(e) => setSelectedAmount(e.target.value)}
												type="number"
												onKeyDown={(event) => onlyNumberForNumberType(event)}
												value={selectedAmount}
												placeholder="Enter amount on slip"
											/>
										</Col>
										<Col xl={6} lg={6} md={6} sm={24} xs={24} className="data_slip">
											<DatePickers
												{...{
													label: 'Date of slip',
													value: proofDateSelected,
													maxDate: 'today',
													onChange: (dateObj, formatStr) => handleProofDate(dateObj, formatStr),
												}}
											/>
										</Col>
										<Col xl={10} lg={12} md={12} sm={24} xs={24} className="sender_name">
											<div>
												<div className="combobox-container" style={{ position: 'relative' }}>
													<Inputbox
														label="Sender Name, if you are using your personal or some other account"
														placeholder="Enter Sender Name"
														value={senderName}
														onChange={(e) => setSenderName(removeNumbersAndSpecialCharacters(e.target.value))}
														onFocus={() => setShowDropdown(true)}
														onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
													/>
													{showDropdown && senderNames && senderNames.length > 0 && (
														<div className="custom-dropdown">
															{senderNamesLoading ? (
																<div style={{
																	padding: '20px',
																	textAlign: 'center'
																}}>
																	<PulseLoader size={10} color={'#e91d24'} loading />
																</div>
															) : (
																senderNames.map(name => (
																	<div
																		key={name}
																		className="dropdown-option"
																		onClick={() => {
																			setSenderName(name);
																			setShowDropdown(false);
																		}}
																	>
																		{name}
																	</div>
																))
															)}
														</div>
													)}
												</div>
											</div>
										</Col>
									</Col>
									<Col xl={24} lg={24} md={24} sm={24} xs={24} className="cheques">
										<ETypo light b1 color="#484B52">
											Cheques may take up to 3 working days to clear before payroll can be run.
										</ETypo>
									</Col>
								</Col>
							</TabPane>
							{/* fund transfer */}
							<TabPane
								onClick={(e) => {
									e.preventDefault();
									setCallPageNumber(pageNumber);
								}}
								tab="Fund Transfer History"
								key="2">
								<Col className="fund_transfer_history">
									<Col xl={24} lg={24} md={24} sm={24} xs={24} className="once_confirm">
										Once we confirm that we have received your salary funds, we’ll run payroll immediately.
									</Col>
									<Col xl={24} lg={24} md={24} sm={24} xs={24}>
										{contentLoading ? (
											<Col style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
												<PulseLoader size={20} color={'#e91d24'} loading />
											</Col>
										) : proof && proof?.length > 0 ? (
											proof?.map((user, index) => {
												return (
													<Col key={index} className="fund_transfer_tab2" style={{ background: user?.background }}>
														<EdenRedCard
															setToastMessageShow={setToastMessageShow}
															refreshData={() => getAllFundTransferHistory(null, true)}
															className="card_history"
															type="proof_of_transfer"
															getAllFundTransferHistory={getAllFundTransferHistory}
															content={user}
														/>
													</Col>
												)
											})
										) : (
											<div style={{ textAlign: 'center' }}>No Records Found</div>
										)}
									</Col>
								</Col>
							</TabPane>
						</Tabs>
					</Col>
				</Row>
			</Col>
		</>
	);
};
export default ProofOfTransferPresentational;
